import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import showToast from "../Global/Hooks/toast";

const ProtectedRoute = () => {
  const isAuthenticated = !!localStorage.getItem("techsbook_customer_portal_token");

  useEffect(() => {
    if (!isAuthenticated) {
      showToast("Please Login In", "error");
    }
  }, [isAuthenticated]);

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
